import { useMemo } from 'react';
import { useApiQuery } from './useApiQuery';
import { jobsApi } from '@/api/jobs';
import type { JobRun, JobRunFilters, JobRunListResponse } from '@/api/jobs';
import mockData from '@/data/mock-data.json';

interface UseJobRunsOptions {
  filters?: JobRunFilters;
  enabled?: boolean;
}

export const useJobRuns = (options: UseJobRunsOptions = {}) => {
  const { filters = {}, enabled = true } = options;

  const mockRuns = useMemo<JobRunListResponse>(() => {
    let runs = mockData.jobRuns as JobRun[];
    if (filters.partnerId) runs = runs.filter((r) => r.partnerId === filters.partnerId);
    if (filters.status) runs = runs.filter((r) => r.status === filters.status);
    return { runs, total: runs.length };
  }, [filters.partnerId, filters.status]);

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<JobRunListResponse>(
    {
      queryFn: () => jobsApi.listRuns(filters),
      mockData: mockRuns,
      enabled,
    },
    [filters.partnerId, filters.status, filters.page, filters.limit],
  );

  return {
    runs: data?.runs ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
